import { Lang } from 'Roblox';
import avatarModule from '../avatarModule';

function advancedBodyColorsModalController($scope, $uibModalInstance, modalData) {
  'ngInject';

  $scope.params = modalData;

  $scope.submit = function() {
    $uibModalInstance.close();
  };

  $scope.close = function() {
    $uibModalInstance.dismiss();
  };
}

avatarModule.controller('advancedBodyColorsModalController', advancedBodyColorsModalController);

export default advancedBodyColorsModalController;
